
import { defineComponent, PropType } from 'vue'
import Dialog from 'primevue/dialog'
import hierarchyManagementDimensionsTableDescriptor from './HierarchyManagementDimensionsTableDescriptor.json'

export default defineComponent({
    name: 'hierarchy-management-dimension-info-dialog',
    components: { Dialog },
    props: { visible: { type: Boolean }, selectedItem: { type: Array as PropType<{ value: string; label: string }[]> } },
    emits: ['close'],
    data() {
        return {
            hierarchyManagementDimensionsTableDescriptor
        }
    },
    watch: {
        nodeMetadata() {
            this.loadNodeData()
        }
    },
    async created() {
        this.loadNodeData()
    },
    methods: {
        loadNodeData() {},
        save() {},
        close() {
            this.$emit('close')
        }
    }
})
